// Easy Responsive Tabs Plugin
(function ($) {
    $.fn.extend({
        easyResponsiveTabs: function (options) {
            //Set the default values, use comma to separate the settings, example:
            var defaults = {
                type: 'default', //default, vertical, accordion;
                width: 'auto',
                fit: true,
                closed: false,
                activate: function(){}
            }
            //Variables
            var options = $.extend(defaults, options);            
            var opt = options, jtype = opt.type, jfit = opt.fit, jwidth = opt.width, vtabs = 'vertical', accord = 'accordion';

            //Events
            $(this).bind('tabactivate', function(e, currentTab) {
                if(typeof options.activate === 'function') {
                    options.activate.call(currentTab, e)
                }
            });

            //Main function
            this.each(function () {
                var $respTabs = $(this);
                var $respTabsList = $respTabs.find('ul.resp-tabs-list');
                $respTabs.find('ul.resp-tabs-list li').addClass('resp-tab-item');
                $respTabs.css({
                    'display': 'block',
                    'width': jwidth
                });

                $respTabs.find('.resp-tabs-container > div').addClass('resp-tab-content');
                jtab_options();
                //Properties Function
                function jtab_options() {
                    if (jtype == vtabs) {
                        $respTabs.addClass('resp-vtabs');
                    }
                    if (jfit == true) {
                        $respTabs.css({ width: '100%', margin: '0px' });
                    }
                    if (jtype == accord) {
                        $respTabs.addClass('resp-easy-accordion');
                        $respTabs.find('.resp-tabs-list').css('display', 'none');
                    }
                }

                //Assigning the h2 markup to accordion title
                var $tabItemh2;
                $respTabs.find('.resp-tab-content').before("<h2 class='resp-accordion' role='tab'><span class='resp-arrow'></span></h2>");

                var itemCount = 0;
                $respTabs.find('.resp-accordion').each(function () {
                    $tabItemh2 = $(this);
                    var innertext = $respTabs.find('.resp-tab-item:eq(' + itemCount + ')').html();
                    $respTabs.find('.resp-accordion:eq(' + itemCount + ')').append(innertext);
                    $tabItemh2.attr('aria-controls', 'tab_item-' + (itemCount));

                    var areaTabValue = $respTabs.find('.resp-tab-item:eq(' + itemCount + ')').attr('area-tab');
                    if (areaTabValue && areaTabValue === 'review_tab') {
                      $tabItemh2.attr('area-tab', 'review_tab');
                    }else{
                      $tabItemh2.attr('area-tab', 'others');
                    }
                  
                    itemCount++;
                });

                //Assigning the 'aria-controls' to Tab items
                var count = 0,
                    $tabContent;
                $respTabs.find('.resp-tab-item').each(function () {
                    $tabItem = $(this);
                    $tabItem.attr('aria-controls', 'tab_item-' + (count));
                    $tabItem.attr('role', 'tab');

                    //First active tab, keep closed if option = 'closed' or option is 'accordion' and the element is in accordion mode 
                    if(options.closed !== true && !(options.closed === 'accordion' && !$respTabsList.is(':visible')) && !(options.closed === 'tabs' && $respTabsList.is(':visible'))) {                  
                        $respTabs.find('.resp-tab-item').first().addClass('resp-tab-active');
                        $respTabs.find('.resp-accordion').first().addClass('resp-tab-active');
                        $respTabs.find('.resp-tab-content').first().addClass('resp-tab-content-active').attr('style', 'display:block');
                    }

                    //Assigning the 'aria-labelledby' attr to tab-content
                    var tabcount = 0;
                    $respTabs.find('.resp-tab-content').each(function () {
                        $tabContent = $(this);
                        $tabContent.attr('aria-labelledby', 'tab_item-' + (tabcount));
                        tabcount++;
                    });
                    count++;
                });

                //Tab Click action function
                $respTabs.find("[role=tab]").each(function () {
                    var $currentTab = $(this);
                    $currentTab.click(function () {

                        var $tabAria = $currentTab.attr('aria-controls');

                        if ($currentTab.hasClass('resp-accordion') && $currentTab.hasClass('resp-tab-active')) {
                            $respTabs.find('.resp-tab-content-active').slideUp('', function () { $(this).addClass('resp-accordion-closed'); });
                            $currentTab.removeClass('resp-tab-active');
                            return false;
                        }
                        if (!$currentTab.hasClass('resp-tab-active') && $currentTab.hasClass('resp-accordion')) {
                            $respTabs.find('.resp-tab-active').removeClass('resp-tab-active');
                            $respTabs.find('.resp-tab-content-active').slideUp().removeClass('resp-tab-content-active resp-accordion-closed');
                            $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');

                            $respTabs.find('.resp-tab-content[aria-labelledby = ' + $tabAria + ']').slideDown().addClass('resp-tab-content-active');
                        } else {
                            $respTabs.find('.resp-tab-active').removeClass('resp-tab-active');
                            $respTabs.find('.resp-tab-content-active').removeAttr('style').removeClass('resp-tab-content-active').removeClass('resp-accordion-closed');
                            $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');
                            $respTabs.find('.resp-tab-content[aria-labelledby = ' + $tabAria + ']').addClass('resp-tab-content-active').attr('style', 'display:block');
                        }
                        //Trigger tab activation event
                        $currentTab.trigger('tabactivate', $currentTab);
                    });
                    //Window resize function                   
                    $(window).resize(function () {
                        $respTabs.find('.resp-accordion-closed').removeAttr('style');
                    });
                });
            });
        }
    });
})(jQuery);

let prevBadgeClick = document.querySelector('.jdgm-prev-badge');
if(prevBadgeClick) {
  document.querySelector('.jdgm-prev-badge').addEventListener('click', function() {
    // for desktop
    
    // document.querySelectorAll('.resp-tabs-list .resp-tab-item').forEach(item => {
    //   item.classList.remove('resp-tab-active');
    // });
    // document.querySelector('.resp-tabs-list .resp-tab-item[aria-controls="tab_item-2"]').classList.add('resp-tab-active');

    document.querySelectorAll('.resp-tabs-list .resp-tab-item').forEach(item => {
      item.classList.remove('resp-tab-active');
    });
    document.querySelector('.resp-tabs-list .resp-tab-item[area-tab="review_tab"]').classList.add('resp-tab-active');

    
  
    // for mobile
    
    // document.querySelectorAll('.resp-tabs-container .resp-accordion').forEach(item => {
    //   item.classList.remove('resp-tab-active');
    // });
    // document.querySelector('.resp-tabs-container .resp-accordion[aria-controls="tab_item-2"]').classList.add('resp-tab-active');

    document.querySelectorAll('.resp-tabs-container .resp-accordion').forEach(item => {
      item.classList.remove('resp-tab-active');
    });
    document.querySelector('.resp-tabs-container .resp-accordion[area-tab="review_tab"]').classList.add('resp-tab-active');
    

    //for both
    
    // document.querySelectorAll('.resp-tabs-container .resp-tab-content').forEach(content => {
    //   content.classList.remove('resp-tab-content-active');
    //   content.style.display = 'none';
    // });
  
    // let activeContent = document.querySelector('.resp-tabs-container .resp-tab-content[aria-labelledby="tab_item-2"]');
    // activeContent.classList.add('resp-tab-content-active');
    // activeContent.style.display = 'block';

    document.querySelectorAll('.resp-tabs-container .resp-tab-content').forEach(content => {
      content.classList.remove('resp-tab-content-active');
      content.style.display = 'none';
    });
  
    let activeContent = document.querySelector('.resp-tabs-container .resp-tab-content[area-content="review_content"]');
    activeContent.classList.add('resp-tab-content-active');
    activeContent.style.display = 'block';
  });
}
